import { rem } from 'polished';
import styled from 'styled-components';

const StyledWrapper = styled.div`
  margin: ${rem('20px')};
  max-width: ${rem('559px')};
`;

const StyledImage = styled.img`
  height: auto;
  width: 100%;
`;

export { StyledWrapper, StyledImage };
